import React from 'react'
import { CMSOpportunityDetailsKeyPartnerShipsType } from '../../../lib/types'
import { RichTextRenderer } from '../../../lib/components'
import { CmsSectionText } from './cms-section-text-content'

const CMSKeyPartnerShips = ({
  keyPartnerships,
}: {
  keyPartnerships?: CMSOpportunityDetailsKeyPartnerShipsType
}) => {
  const renderPartnershipLayout = () => {
    if (keyPartnerships?.sectionVariant === 'detailed') {
      return (
        <section className='flex gap-40px' data-testid='cms-key-partners-grid'>
          <section
            className={`image-grid image-grid--stretch-cards grid-${keyPartnerships?.layoutColumns}`}
          >
            {keyPartnerships?.partnerShips?.map((card, idx: number) => (
              <section className='card' key={idx}>
                <img
                  src={card?.partnerImage}
                  alt={`Jupitice Partner ${idx + 1}`}
                  className='height-108percent width-100percent'
                />
                {card?.text?.length && (
                  <CmsSectionText
                    className='mt-24px'
                    dataTestId={`cms-key-partner-description-text-${idx}`}
                  >
                    <RichTextRenderer content={card?.text} variant='opportunity-details' />
                  </CmsSectionText>
                )}
              </section>
            ))}
          </section>
        </section>
      )
    }

    if (keyPartnerships?.sectionVariant === 'gallery') {
      return (
        <section
          className={
            'opportunity-cms-section-gallery flex flex-wrap flex-justify-center width-80percent'
          }
          data-testid='cms-key-partners-gallery'
        >
          {keyPartnerships?.partnerShips?.map((card, idx: number) => (
            <section
              className='flex flex-justify-center flex-align-center flex-item-2col height-min-150px'
              key={idx}
            >
              <img
                src={card?.partnerImage}
                alt={`Jupitice Partner ${idx + 1}`}
                className='width-80percent'
              />
            </section>
          ))}
        </section>
      )
    }

    return null
  }

  return (
    <section data-testid='cms-key-partnerships-content'>
      {keyPartnerships?.partnerShipText?.length && (
        <CmsSectionText dataTestId='cms-key-partnerships-text'>
          <RichTextRenderer
            content={keyPartnerships.partnerShipText}
            variant='opportunity-details'
          />
        </CmsSectionText>
      )}
      {renderPartnershipLayout()}
    </section>
  )
}

export { CMSKeyPartnerShips }
